import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

export const MoldSearchParamsSchema = z
  .object({
    q: z.string().optional(),
    supplierId: z.coerce.number().optional(),
    hasCurrentAssignment: z.coerce.boolean().optional(),
    itemId: z.coerce.number().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type MoldSearchParams = z.infer<typeof MoldSearchParamsSchema>

export const MoldSearchResultModelSchema = z.object({
  id: z.number(),
  assetNumber: z.string(),
  moldNumber: z.string(),
  currentSupplier: z
    .object({
      id: z.number(),
      code: z.string(),
      name: z.string(),
    })
    .nullable(),
  assignedDate: z.string().nullable(),
  associatedItemsCount: z.number(),
})

export type MoldSearchResultModel = z.infer<typeof MoldSearchResultModelSchema>

export const MoldSearchResultSchema = z
  .object({
    data: z.array(MoldSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type MoldSearchResult = z.infer<typeof MoldSearchResultSchema>
